module.exports = __webpack_public_path__ + "static/6-c76aa086837762c7b99f45b5ba73979e.jpg";